import React, { ReactNode, createContext, useContext } from 'react';
import { UserService } from 'src/services/userService';

const UserServiceContext = createContext<UserService | undefined>(undefined);

interface UserServiceProviderProps {
  children: ReactNode;
}

export const UserServiceProvider: React.FC<UserServiceProviderProps> = ({
  children,
}) => {
  const userService = new UserService();

  return (
    <UserServiceContext.Provider value={userService}>
      {children}
    </UserServiceContext.Provider>
  );
};

export const useUserService = (): UserService => {
  const userService = useContext(UserServiceContext);
  if (!userService) {
    throw new Error('useUserService must be used within a UserServiceProvider');
  }
  return userService;
};
